import { render, staticRenderFns } from "./liveNews.vue?vue&type=template&id=a3b37cbe&scoped=true"
import script from "./liveNews.vue?vue&type=script&lang=js"
export * from "./liveNews.vue?vue&type=script&lang=js"
import style0 from "./liveNews.vue?vue&type=style&index=0&id=a3b37cbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b37cbe",
  null
  
)

export default component.exports